import React from 'react'
import ButtonList from './ButtonList'
import VideoContainer from './VideoContainer'

const Feed = () => {
  return (
    <div className='z-10 mt-20 ml-5 mr-3 w-[80%]'>
     <ButtonList />
     <VideoContainer />
    </div>
  )
}

export default Feed